import { gsap } from "gsap";

export class SoccerBallController {
  constructor(ballEl, options = {}) {
    this.ball = ballEl;

    // physics
    this.y = 0;
    this.vy = 0;

    this.gravity = options.gravity ?? 0.6;
    this.kickStrength = options.kickStrength ?? -12;
    this.groundY = options.groundY ?? 0;
    this.bounceRestitution = options.bounceRestitution ?? 0.55;
    this.onUpdate = options.onUpdate ?? null;
    this.inputTarget = options.inputTarget !== undefined ? options.inputTarget : window;

    this.isRunning = false;

    this._bindInput();
    this._loop = this._loop.bind(this);

    gsap.ticker.add(this._loop);
  }

  start() {
    this.isRunning = true;
  }

  stop() {
    this.isRunning = false;
  }

  kick() {
    // instant upward impulse
    this.vy = this.kickStrength;

    gsap.to(this.ball, {
      scale: 1.1,
      duration: 0.08,
      yoyo: true,
      repeat: 1,
      ease: "power1.out"
    });
  }

  _bindInput() {
    if (this.inputTarget === null) return;
  //  this._inputHandler = () => this.kick();
  //  this.inputTarget.addEventListener("pointerdown", this._inputHandler);
  }

  destroy() {
    this.stop();
    gsap.ticker.remove(this._loop);
    if (this.inputTarget && this._inputHandler) {
      this.inputTarget.removeEventListener("pointerdown", this._inputHandler);
    }
  }

  _loop() {
    if (!this.isRunning) return;

    // gravity
    this.vy += this.gravity;
    this.y += this.vy;

    // ground collision — damped bounce, settles when too slow to matter
    if (this.y > this.groundY) {
      this.y = this.groundY;
      this.vy = Math.abs(this.vy) > 1 ? -this.vy * this.bounceRestitution : 0;
    }

    gsap.set(this.ball, { y: this.y });

    if (this.onUpdate) this.onUpdate({ y: this.y, vy: this.vy });
  }
}